<template>
    <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
        <form class="form-horizontal">
            <div class="row">
                <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right required">
                            {{ $t("serviceQuotation.quotationDate") }}
                        </label>
                        <div class="col-md-7">
                            <a-date-picker v-model="model.quotation_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                                class="ts-w-full" />
                            <div class="text-danger" v-if="errors.has('quotation_date')">
                                {{ errors.first("quotation_date") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right">
                            {{ $t("serviceQuotation.customer") }}
                        </label>
                        <div class="col-md-7">
                            <input readonly type="text"
                                :value="service_ticket_info ? service_ticket_info.customer_name : null"
                                class="form-control" />
                            <div class="validate" v-if="errors.has('customer_id')">
                                {{ errors.first("customer_id") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right">
                            {{ $t("serviceQuotation.servedBy") }}
                        </label>
                        <div class="col-md-7">
                            <input readonly :value="service_ticket_info ? service_ticket_info.served_by_name : null"
                                type="text" class="form-control" />
                            <div class="validate" v-if="errors.has('credit_term')">
                                {{ errors.first("credit_term") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right">{{
                            $t("serviceQuotation.repairedBy")
                            }}</label>
                        <div class="col-md-7">
                            <input readonly :value="service_ticket_info ? service_ticket_info.ticket_owner_name : null"
                                type="text" class="form-control" />
                            <div class="validate" v-if="errors.has('valid_until')">
                                {{ errors.first("valid_until") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right required">{{ $t("serviceQuotation.ticketNo")
                            }}</label>
                        <div class="col-md-7">
                            <a-select v-model="model.service_ticket_id" :options="serviceTickets" showSearch
                                :filterOption="(input, option) =>
                                    option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    " @search="handleSearchServiceTicket" @change="onChangeServiceTicket"
                                class="ts-w-full" :class="{ 'is-invalid': errors.has('service_ticket_id') }"></a-select>
                            <div class="invalid-feedback" v-if="errors.has('service_ticket_id')">
                                {{ errors.first("service_ticket_id") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right required">
                            {{ $t("serviceQuotation.quotationStatus") }}
                        </label>
                        <div class="col-md-7">
                            <a-select v-model="model.quotation_status_id" :options="serviceQuotationStatus"
                                class="ts-w-full"
                                :class="{ 'is-invalid': errors.has('quotation_status_id') }"></a-select>
                            <div class="text-danger" v-if="errors.has('valid_date')">
                                {{ errors.first("valid_date") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right required">
                            {{ $t("serviceQuotation.chargeStatus") }}
                        </label>
                        <div class="col-md-7">
                            <a-select v-model="model.charge_status" :options="chargeStatus"
                                class="ts-w-full"></a-select>
                            <div class="text-danger" v-if="errors.has('valid_date')">
                                {{ errors.first("valid_date") }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-3 col-form-label ts-text-right">{{
                            $t("serviceQuotation.customerPhone")
                            }}</label>
                        <div class="col-md-7">
                            <input readonly :value="service_ticket_info ? service_ticket_info.contact_number : null"
                                type="text" class="form-control" />
                            <div class="validate" v-if="errors.has('pic')">
                                {{ errors.first("pic") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";

export default {
    name: "info",
    props: ["value", "validate", "loading"],
    data() {
        return {
            errors: new Errors(),
            model: {},
            searching: false,
            service_ticket_info: {}
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("customerService/serviceQuotation", ["formViewDatas"]),
        customerList() {
            return [];
        },
        serviceTickets() {
            if (this.formViewDatas.serviceTickets) {
                return this.formViewDatas.serviceTickets
                    .map(el => ({
                        value: el.service_ticket_id,
                        label: el.ticket_no
                    }))
            }
            return []
        },
        serviceQuotationStatus() {
            if (this.formViewDatas.serviceQuotationStatus) {
                return this.formViewDatas.serviceQuotationStatus
                    .map(el => ({
                        value: el.quotation_status_id,
                        label: el.quotation_status
                    }))
            }
            return []
        },
        chargeStatus() {
            return [
                {
                    value: 'pending',
                    label: 'Pending'
                },
                {
                    value: 'charged',
                    label: 'Charged'
                },
                {
                    value: 'free',
                    label: 'Free'
                },
            ];
        },
    },
    methods: {
        ...mapActions("customerService/serviceQuotation", ["getFormViewModel"]),
        handleSearchServiceTicket: debounce(function (value) {
            // this.searching = true;
            // this.getFormViewModel({
            //     index: "customer",
            //     params: {
            //         fnName: "customer",
            //         search: value
            //     }
            // }).finally(() => (this.searching = false));
        }, 800),
        onChangeServiceTicket(value) {
            this.$emit('update:loading', true)
            this.service_ticket_info = this.formViewDatas.serviceTickets.find(
                el => el.service_ticket_id == value
            );
            this.getFormViewModel({
                index: "serviceTicketDetail",
                params: {
                    fnName: "serviceTicketDetail",
                    service_ticket_id: value
                }
            })
                .then(response => {
                    this.model.details = response.data.serviceTicketDetail;
                })
                .finally(() => this.$emit('update:loading', false));
        }
    },
    watch: {
        validate: function (error) {
            this.errors = new Errors(error.errors);
        },
    }
};
</script>
